import { render } from "./Classroom.vue?vue&type=template&id=685b6920&ts=true"
import script from "./Classroom.vue?vue&type=script&lang=ts"
export * from "./Classroom.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__